import { FormField, Radio } from "semantic-ui-react";

export const NewRadioButtonFieldComponent = (props: {
  props: NewRadioButtonFieldComponentProps;
  data: any;
  setData: any;
}) => {
  return (
    <div className="radio-button">
      <FormField>{props.props.label}</FormField>
      {props.props.options.map((option) => (
        <FormField>
          <Radio
            label={option.label}
            value={option.value}
            checked={props.data[props.props.key] === option.value}
            onChange={() =>
              props.setData({ ...props.data, [props.props.key]: option.value })
            }
          />
        </FormField>
      ))}
    </div>
  );
};

export type NewRadioButtonFieldComponentProps = {
  type: "radio_button";
  key: string;
  label: string;
  options: {
    label: string;
    value: string;
  }[];
};
